import { DateFormatter } from '@repo/toolkit/date'
import Badge from '@repo/ui/badge'
import React from 'react'

import {
  StaffPaymentStatusEnum,
  staffPaymentStatusEnumMapping
} from '../../lib/types/enums/affected-staff/staff-payment-status.enum'

type Props = {
  paymentStatus: StaffPaymentStatusEnum
  paymentExportedAt?: Date
  paymentValidatedAt?: Date
}

const SalaryPaymentStatus: React.FC<Props> = ({
  paymentStatus,
  paymentExportedAt,
  paymentValidatedAt
}) => {
  if (paymentStatus === StaffPaymentStatusEnum.PENDING) return '-'
  return (
    <div className="flex flex-col gap-2 p-2">
      <Badge
        className="h-auto min-h-7 py-1"
        text={staffPaymentStatusEnumMapping[paymentStatus].label}
        color={staffPaymentStatusEnumMapping[paymentStatus].bgColor}
        textColor={staffPaymentStatusEnumMapping[paymentStatus].color}
      />

      {paymentStatus === StaffPaymentStatusEnum.EXPORTED && paymentExportedAt && (
        <Badge text={DateFormatter.DDMMYYYY(paymentExportedAt)} />
      )}
      {paymentStatus === StaffPaymentStatusEnum.VALIDATED && paymentValidatedAt && (
        <Badge text={DateFormatter.DDMMYYYY(paymentValidatedAt)} />
      )}
    </div>
  )
}

export default SalaryPaymentStatus
